import React from 'react';
import { Link } from 'react-router-dom';

const Sidebar = () => {
  return (
    <>{/* ======= Sidebar ======= */}
<aside id="sidebar" className="sidebar">
  <ul className="sidebar-nav" id="sidebar-nav">
    <li className="nav-item">
      <Link className="nav-link " to="/">
        <i className="bi bi-grid" />
        <span>Dashboard</span>
      </Link>
    </li>{/* End Dashboard Nav */}
    <li className="nav-item">
      <Link className="nav-link collapsed" data-bs-target="#components-nav" data-bs-toggle="collapse" to="/" aria-expanded="true">
        <i className="bi bi-menu-button-wide" /><span>Products</span><i className="bi bi-chevron-down ms-auto" />
      </Link>
      <ul id="components-nav" className="nav-content collapse " data-bs-parent="#sidebar-nav">
      <li>
      <Link to="/add-product">Add Product</Link>
      </li>
      <li>
      <Link to="/view-my-product">View My Product</Link>
      </li>
     </ul>
     </li>
   
     <li class="nav-item">
        <Link class="nav-link" data-bs-target="#forms-nav" data-bs-toggle="collapse" to="/" aria-expanded="true">
          <i class="bi bi-journal-text"></i><span>Orders</span><i class="bi bi-chevron-down ms-auto"></i>
        </Link>
        <ul id="forms-nav" class="nav-content collapse show" data-bs-parent="#sidebar-nav" >
          <li>
            <Link to="/overview-orders">
              <i class="bi bi-circle"></i><span>Overview Orders</span>
            </Link>
          </li>
          <li>
            <Link to="/view-confirmed-orders">
              <i class="bi bi-circle"></i><span>Confirm Orders</span>
            </Link>
          </li>
          <li>
            <Link to="/shipping-orders">
              <i class="bi bi-circle"></i><span>Shipping Orders</span>
            </Link>
          </li>
        </ul>
      </li>
       <li class="nav-item">
        <Link class="nav-link" data-bs-target="#forms-nav" data-bs-toggle="collapse" to="//manage-transaction" aria-expanded="true">
          <i class="bi bi-journal-text"></i><span>Transactions Manage</span><i class="bi bi-chevron-down ms-auto"></i>
        </Link>
        <ul id="forms-nav" class="nav-content collapse show" data-bs-parent="#sidebar-nav" >
          <li>
            <Link to="/manage-transaction">
              <i class="bi bi-circle"></i><span>Transaction Lists</span>
            </Link>
          </li>
          <li>
            <Link to="/transaction/id">
              <i class="bi bi-circle"></i><span>Transaction Details</span>
            </Link>
          </li>
          <li>
            <Link to="/">
              <i class="bi bi-circle"></i><span>Analytics</span>
            </Link>
          </li>
        </ul>
      </li>

    <li className="nav-item">
      <Link className="nav-link collapsed" to="/signup">
        <i className="bi bi-card-list" />
        <span>Register</span>
      </Link>
    </li>{/* End Register Page Nav */}
    <li className="nav-item">
      <Link className="nav-link collapsed" to="/login">
        <i className="bi bi-box-arrow-in-right" />
        <span>Login</span>
      </Link>
    </li>{/* End Login Page Nav */}
  
  </ul>
</aside>{/* End Sidebar*/}

    </>
  )
}

export default Sidebar